<ds-loading *ngIf="loader === true"></ds-loading>
<div class="flex flex-col max-w-240 md:min-w-160 -m-6">

    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{hdng_nm}} Contact</div>
        <button mat-icon-button (click)="Close()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="close"></mat-icon>
        </button>
    </div>
    <form [formGroup]="contactForm" class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">

        <div fxLayout="row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Select Contact Type</mat-label>
                <mat-select formControlName="cntct_type_id" placeholder="Select Contact Type">
                    <mat-option *ngFor="let c of cntctTypsLst" [value]="c.cntct_type_id">{{c.cntct_type_nm}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="row">

            <mat-form-field class="frmfld m-2">
                <mat-label>Name</mat-label>
                <input matInput [placeholder]="'Name'" formControlName="cntct_nm">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field appearance="fill" class="frmfld m-2">
                <mat-label>Mobile Number</mat-label>
                <input matInput [placeholder]="'Mobile Number'" formControlName="mble_ph">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:phone'"></mat-icon>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field appearance="fill" class="frmfld m-2">
                <mat-label>Alternate Mobile Number</mat-label>
                <input matInput [placeholder]="'Alternate Mobile Number'" formControlName="mble2_ph">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:phone'"></mat-icon>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field appearance="fill" class="frmfld m-2">
                <mat-label>Email</mat-label>
                <input matInput [placeholder]="'Email ID'" formControlName="eml_tx">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:mail'"></mat-icon>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Desgination</mat-label>
                <input matInput formControlName="dsgnt_nm" placeholder="Enter Desgination">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:academic-cap'"></mat-icon>
            </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">
            </div>
            <div class="flex items-center mt-4 sm:mt-0">
                <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()">
                    Cancel
                </button>
                <button mat-button [color]="'warn'" [matTooltip]="'Delete'" (click)="delete()" *ngIf="dialogData.edit_in ==1">
                    Delete
                </button>
                <button class="order-first sm:order-last m-2" mat-flat-button [color]="'primary'" (click)="send()">
                    {{sve_btn}}
                </button>
            </div>
        </div>

    </form>
    <ng-template #deleteCntctCnfrmDialog>
        <h2 matDialogTitle>Are You Sure Want To Delete This Contact?</h2>
        <mat-dialog-actions align="end">
            <button mat-button (click)="closeDialog()">No</button>
            <button mat-button (click)="deleteCntct()">Yes</button>
        </mat-dialog-actions>
    </ng-template>
    
</div>